// src/data/newsData.js

const newsData = [


   {
    title: "Two of our papers got accepted for The IEEE CCWC-2026" ,
    date: "2025-08-01T10:00:00Z",
    description: "Check out more later",
    link: "#"
  },
   {
    title: "Our paper got accepted for The 59th Hawaii International Conference on System Sciences (HICSS)",
    date: "2025-08-01T10:00:00Z",
    description: "Check out more later",
    link: "#"
  },
  
  {
    title: "Two of our works got accepted for the AI in Healthcare Conference at Rice University",
    date: "2025-08-01T10:00:00Z",
    description: "Check out more later",
    link: "#"
  },
  {
    title: "Three of our papers got accepted at the  IEEE Smart World Congress Conference",
    date: "2025-08-01T10:00:00Z",
    description: "Check out more later",
    link: "#"
  },
  {
    title: "One of our papers got accepted at the IEEE Metaverse Conference",
    date: "2025-07-01T10:00:00Z",
    description: "Check out more later",
    link: "#"
  },
  {
    title: "Two of our papers got accepted at the IEEE Conference on Artificial Intelligence",
    date: "2025-01-10T10:00:00Z",
    description: "Check out more later",
    link: "#"
  },
];

export default newsData;
